import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { isEnabledSendLetter, getMaxSendLetterCount } from '../../../utils/planUtils';

const styles = () => ({
  root: {
    height: '40px',
    backgroundColor: '#FFF3C6',
    color: '#181819',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: 'bold',
  },

  linkBtn2: {
    cursor: 'pointer',
    color: '#1A65FF',
    marginLeft: '15px',
    fontWeight: 'normal',

    '&:hover': {
      background: 'rgba(243, 247, 255, .2)',
    }
  },
})

class IsMaxLetterSendingNotification extends React.Component {
  isOverLimit = () => {
    const { user } = this.props;
    const currentCount = (user && user.active_plan_letter_count) ? user.active_plan_letter_count : 0;
    return currentCount >= getMaxSendLetterCount(user);
  }

  render() {
    const { classes, user } = this.props;

    if (!isEnabledSendLetter(user)) {
      return null;
    }

    if (!this.isOverLimit()) {
      return null;
    }

    return (
      <div className={classes.root}>
        送付通数の上限に達しています
        <span className={classes.linkBtn2} onClick={this.props.action}>プランを変更する</span>
      </div>
    );
  }
}

IsMaxLetterSendingNotification.propTypes = {
  classes: PropTypes.object,
  user: PropTypes.object,
  action: PropTypes.func,
}

export default withStyles(styles)(IsMaxLetterSendingNotification);


// WEBPACK FOOTER //
// ./src/components/common/UnDeletableNotification/IsMaxLetterSendingNotification.jsx